import cx from "clsx";
import Styles from "./ModalFooter.module.scss";

type Props = {
	acceptLabel?: string;
	bottomSticky?: boolean;
	isSubmitting?: boolean;
	onClickAccept: () => void | boolean | Promise<boolean> | Promise<void>;
	onClickCancel: () => void;
	submitInvalid?: boolean;
};

export function ModalFooter({
	isSubmitting = false,
	submitInvalid = false,
	onClickCancel,
	onClickAccept,
	acceptLabel = "保存",
	bottomSticky = true
}: Props) {
	return (
		<div
			className={cx(
				Styles.ModalFooter,
				bottomSticky ? Styles.BottomSticky : ""
			)}
		>
			<button
				className={Styles.CancelButton}
				disabled={isSubmitting}
				onClick={onClickCancel}
				type="button"
			>
				キャンセル
			</button>
			<button
				className={Styles.SubmitButton}
				disabled={isSubmitting || submitInvalid}
				onClick={onClickAccept}
				type="button"
			>
				{acceptLabel}
			</button>
		</div>
	);
}
